import React, { useEffect, useState } from 'react';
import { Modal } from '../../ui/Modal/Modal';
import styles from './ModalBitrixChatBotIntegrationForm.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import Title from '../../ui/Title/Title';
import { BitrixIcon } from '../../assets/icons/BitrixIcon';
import Input from '../../ui/Input/Input';
import Button from '../../ui/Button/Button';
import { ClipLoader } from 'react-spinners';
import { useModal } from '../../context/ModalContext';
import {
    setActiveDataBitrixChatBot,
    setNewDataBitrixChatBot,
} from '../../store/slices/bitrixChatBotSlice';
import { stepsDataBitrixChatBot } from '../../assets/consts/tooltipDataBitrixChatBot';
import { initBitrixBot } from '../../utils/api/actions/integrations/bitrixBot';

const BitrixSuccessMessage = ({ closeModal, closeAddIntegrationModal }) => {
    const [countdown, setCountdown] = useState(5);
    const dispatch = useDispatch();

    const id = localStorage.getItem('@storage_User_Id');

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);

        if (countdown === 0) {
            closeModal();
            closeAddIntegrationModal();
            //   dispatch(getIntegrationsBitrixList(id));
            dispatch(setActiveDataBitrixChatBot(null));
            dispatch(setNewDataBitrixChatBot(null));
        }

        return () => clearInterval(timer);
    }, [countdown, closeModal, dispatch, id, closeAddIntegrationModal]);

    return (
        <div className={styles.successMessage}>
            <h2>Вы успешно подключили Bitrix чат-бот!</h2>
            <div>
                <ClipLoader /> Окно закроется через {countdown} секунд.
            </div>
        </div>
    );
};

export const ModalBitrixChatBotIntegrationForm = ({
    visible,
    handlerClose,
}) => {
    const dispatch = useDispatch();

    const { closeModal } = useModal();

    const user = useSelector((state) => state?.user?.data);

    const [isBitrixConnected, setIsBitrixConnected] = useState(false);
    const [loading, setLoading] = useState(false);
    const [apiURL, setApiURL] = useState('');
    const [chatBotId, setChatBotId] = useState('');
    const [clientId, setClientId] = useState('');
    const [errors, setErrors] = useState({
        apiURL: '',
        chatBotId: '',
        clientId: '',
    });

    const hintBitrix = {
        id: 'bitrix',
        stepsData: stepsDataBitrixChatBot,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'apiURL') setApiURL(value);
        if (name === 'chatBotId') setChatBotId(value);
        if (name === 'clientId') setClientId(value);
    };

    const handleSendDataInitBitrix = () => {
        const data = {
            userId: user.id,
            apiURL: apiURL,
            chatBotId: Number(chatBotId),
            clientId: clientId,
        };
        // console.log(
        //     'initData chat bot',
        //     data,
        //     setLoading,
        //     setIsBitrixConnected,
        //     setErrors
        // );

        if (!errors.length > 0)
            dispatch(initBitrixBot(data, setLoading, setIsBitrixConnected));
    };

    const handleKeyDown = (e) => {
        if (apiURL.length > 0 && e.key === 'Enter') {
            handleSendDataInitBitrix();
        }
    };

    useEffect(() => {
        setErrors((prev) => ({
            ...prev,
            apiURL: apiURL.trim() ? '' : 'Поле не может быть пустым',
            chatBotId: chatBotId.trim() ? '' : 'Поле не может быть пустым',
            clientId: clientId.trim() ? '' : 'Поле не может быть пустым',
        }));
    }, [apiURL, chatBotId, clientId]);

    return (
        <Modal
            styleClose={styles.closeIcon}
            visible={visible}
            handleClose={handlerClose}
        >
            <div className={styles.container}>
                <div className={styles.header}>
                    <Title title="Новая интеграция" className={styles.title} />
                    <BitrixIcon width={75} height={55} fill={'#3e8fcb'} />
                    <Title title="чат бот" className={styles.subtitle} />
                </div>
                {isBitrixConnected ? (
                    <BitrixSuccessMessage
                        closeModal={handlerClose}
                        closeAddIntegrationModal={closeModal}
                    />
                ) : (
                    <div className={styles.form}>
                        <div className={styles.inputContainer}>
                            <Input
                                onKeyPress={handleKeyDown}
                                className={styles.child}
                                name={'apiURL'}
                                label="API URL"
                                labelStyle={styles.labelInput}
                                backgroundStyle={styles.labelBackground}
                                inputStyle={`${styles.input}`}
                                value={apiURL}
                                placeholder={'API URL'}
                                type={'text'}
                                hint={hintBitrix}
                                onChange={handleInputChange}
                            />
                            {errors.apiURL && (
                                <div className={styles.errorMessage}>
                                    {errors.apiURL}
                                </div>
                            )}
                        </div>

                        <div className={styles.inputContainer}>
                            <Input
                                onKeyPress={handleKeyDown}
                                className={styles.child}
                                name={'chatBotId'}
                                label="BOT_ID"
                                labelStyle={styles.labelInput}
                                backgroundStyle={styles.labelBackground}
                                inputStyle={`${styles.input}`}
                                value={chatBotId}
                                placeholder={'BOT_ID'}
                                type={'text'}
                                onChange={handleInputChange}
                            />
                            {errors.chatBotId && (
                                <div className={styles.errorMessage}>
                                    {errors.chatBotId}
                                </div>
                            )}
                        </div>

                        <div className={styles.inputContainer}>
                            <Input
                                onKeyPress={handleKeyDown}
                                className={styles.child}
                                name={'clientId'}
                                label="CLIENT_ID"
                                labelStyle={styles.labelInput}
                                backgroundStyle={styles.labelBackground}
                                inputStyle={`${styles.input}`}
                                value={clientId}
                                placeholder={'CLIENT_ID'}
                                type={'text'}
                                onChange={handleInputChange}
                            />
                            {errors.clientId && (
                                <div className={styles.errorMessage}>
                                    {errors.clientId}
                                </div>
                            )}
                        </div>

                        <Button
                            onClick={handleSendDataInitBitrix}
                            className={styles.button}
                            titleClassName={styles.buttonTitle}
                            leftIcon={
                                loading ? (
                                    <ClipLoader size={16} color={'white'} />
                                ) : null
                            }
                            title={loading ? 'Подождите' : 'Отправить'}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
};
